import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{
      fontFamily: '"Helvetica Neue", sans-serif',
      background: '#fefefe',
      color: '#212121',
      margin: 0,
      padding: 0,
      minHeight: '100vh'
    }}>
      <div className="policy-page-inner" style={{
        maxWidth: '880px',
        margin: '20px auto',
        padding: '24px',
        background: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
      }}>
        <h1 style={{
          textAlign: 'center',
          color: '#0C7B3D',
          fontSize: '2em',
          marginBottom: '1em'
        }}>
          Privacy Policy - IOS
        </h1>
        <p style={{ textAlign: 'center', fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Last Updated: January 16, 2026
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          <strong>JEJELY ULTIMATE LIMITED</strong> is a duly registered company in Nigeria. It has been authorized and approved by the <strong>Federal Competition and Consumer Protection Commission (FCCPC)</strong> to operate financial loan services.
        </p>
        
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          <strong>Fairloner</strong> is a digital loan application independently developed and operated by <strong>JEJELY ULTIMATE LIMITED.</strong> The company has granted Fairloner the right to utilize the FCCPC-issued digital lending authorization, enabling it to legally conduct digital lending operations within Nigeria.
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          This privacy policy outlines the information that Fairloner ("we", "our", or "us") collects from any users or visitors ("you", "your", or "users") and the extent to which we may use and transfer it when you register, access or use our mobile application (Fairloner), website, products, and services (collectively referred to as "Services"). The Services provide users with the opportunity to apply for and obtain small loans subject to agreed-upon terms and conditions. By accessing and/or using our Services, you accept and agree to the practices described in this privacy policy. Please read this privacy policy carefully before submitting personal information or using our Services. If you do not agree to this privacy policy, please contact us. Fairloner may modify this policy at any time without notice. We recommend that users and visitors to our website periodically review this policy to stay informed of the latest changes. What personal data we collect and why we collect it.
        </p>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          1. Scope of This Privacy Policy
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          This Policy applies to all websites and mobile applications operated by or on behalf of Fairloner, including affiliated entities worldwide. It also applies to personal information we may collect:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li>Through our products and services.</li>
          <li>When you interact with us outside of Fairloner's digital platforms—such as in person, over the phone, or through other communication channels.</li>
          <li>From our employees, debt collectors, third-party investigators, and other business partners (collectively referred to as "Business Partners").</li>
        </ul>
        
        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          2. Our Commitment to Data Privacy and Processing Principles
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Fairloner is a mobile application (the "App") available for download from the App Store, which you have installed on your mobile phone, smartphone, or handheld device (collectively referred to as the "Device").To the extent required by applicable laws, whenever Fairloner collects personal information, it will adhere to the following principles:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li>Provide you with timely and appropriate notice regarding our data practices</li>
          <li>Collect your personal information solely for specified purposes, ensuring that the information collected is relevant, adequate, and not excessive in relation to those purposes</li>
          <li>Process your personal information only in a manner consistent with the original purposes of collection or with your subsequent consent</li>
          <li>Take commercially reasonable steps to ensure that your personal information is reliable for its intended use, accurate, complete, and, where necessary, kept up to date</li>
          <li>Not use your personal information for direct marketing purposes without first providing you with an opportunity to opt out</li>
          <li>Take appropriate measures—through contracts or other means—to ensure adequate protection of personal information that is disclosed to third parties or transferred across borders, including transfers within Fairloner</li>
        </ul>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          3. Information We Collect
        </h2>
        <h3 style={{
          color: '#0C7B3D',
          marginTop: '1.2em'
        }}>
          Identity & Device Data
        </h3>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li><strong>Contact Information</strong> – This includes your name, company name, job title, physical address, email address, and phone number.</li>
          <li><strong>Additional Personal Details</strong> – Information that helps us understand you better, such as your gender, age, date of birth, nationality, how you use our products, and other demographic data.</li>
          <li><strong>User Submissions</strong> – Any comments, questions, requests, or orders that you may submit to us.</li>
          <li><strong>Financial Information</strong> – Details necessary to process loans and payments, including bank card information, bank account numbers, or other financial details</li>
          <li><strong>Login Credentials</strong> – Information used to access our services, which may include your login credentials and, if applicable, social media account details used for authentication.</li>
          <li><strong>Preferences</strong> – Information regarding your communication preferences and the types of products or services you are interested in.</li>
          <li><strong>Selected Contact Information</strong> – We only access the specific contacts you explicitly select and authorize within the app. This information is used solely for risk assessment, fraud prevention, and debt collection purposes, especially in cases where the contact information provided in your credit agreement is false, invalid, or unresponsive. We do not collect or upload your entire contact list.</li>
        </ul>

        <h3 style={{
          color: '#0C7B3D',
          marginTop: '1.2em'
        }}>
          Location
        </h3>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          User location helps to locate and verify addresses while determining that users are indeed in Nigeria, as only Nigerian citizens can enjoy our loan services. This can help make better credit risk decisions and speed up the KYC process.
        </p>

        <h3 style={{
          color: '#0C7B3D',
          marginTop: '1.2em'
        }}>
          Ads Tracking
        </h3>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          This permits the application to access your IDFA (Identifier for Advertisers) and/or IDFV (Identifier for Vendors) in order to track and optimize your experience during the loan application process, thereby enhancing the quality and relevance of the services provided.
        </p>
        
        <h3 style={{
          color: '#0C7B3D',
          marginTop: '1.2em'
        }}>
          Camera & Photo
        </h3>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          We may request access to your device's camera to capture facial images needed for identity verification through facial recognition technology, enhancing the security and convenience of your app experience.We do not access or use your photo library, and no photos are read from or saved to your device's photo library. All images used are directly captured via the camera for verification purposes only.
        </p>

        <p style={{
          backgroundColor: '#ffdddd',
          color: '#b30000',
          padding: '12px',
          borderLeft: '4px solid #b30000',
          borderRadius: '4px',
          fontSize: '1rem',
          lineHeight: '1.7',
          marginBottom: '0.9em'
        }}>
          We will upload the collected data to the server (<a href="https://jejely.net" target="_blank" style={{ color: '#b30000' }}><strong>https://jejely.net</strong></a>) in a secure network environment
        </p>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          4. Use of Information
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Fairloner may use your personal information to provide and improve services, maintain relationships with you and our business partners, and fulfill legal obligations. This includes delivering services and supporting transactions requested by you or our partners, providing you with relevant product, service, and promotional information, responding to your inquiries and requests. customizing our websites, apps, and products according to your preferences and technology. maintaining system security and developing new features. complying with laws, regulations, and court orders. preventing fraud and other unlawful activities. and protecting the rights and interests of Fairloner and its users. You have the right to request restrictions on the processing of your personal data, such as suspending processing to verify its accuracy.
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Additionally, Fairloner may use your personal information for other legitimate purposes consistent with the context in which it was collected or with your consent. We may also anonymize or aggregate the information for research and product development purposes, ensuring that it does not identify you personally.
        </p>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          5. Sharing Your Data
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          We may share your personal information with trusted third-party service providers who assist us in operating our business. These providers are authorized to use your information solely to perform services on our behalf and are required to comply with all applicable privacy and data protection laws.
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          In some cases, Fairloner may share your personal information with business partners who collaborate with us to deliver products and services. We ensure that these partners handle your information in accordance with this Policy, any relevant privacy statements, and all applicable laws.
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Fairloner may disclose your personal information when we believe, in good faith, that disclosure is necessary to:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li>Comply with legal obligations, including laws, regulations, court orders, or other legal processes</li>
          <li>Detect, prevent, or respond to fraud, intellectual property violations, breaches of contract, legal violations, or misuse of our platforms and services</li>
          <li>Protect the rights, property, safety, or welfare of Fairloner, you, or others</li>
          <li>Other similar circumstances, while taking appropriate measures to safeguard your data</li>
        </ul>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          6.Data Retention
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          We retain your personal information only for as long as necessary to provide our services, fulfill legal and regulatory obligations, resolve disputes, prevent fraud, and enforce our agreements. If we decide to discontinue our services to you, your data will be deleted accordingly.
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Even after your account has been closed, we may continue to retain certain personal and transactional information if required by applicable laws, regulatory guidelines, banking partners, or card processors. This is to ensure proper transaction processing, settlement, refund management, fraud prevention, and legal compliance.
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Where feasible, we will destroy personal data that is no longer needed. We also conduct periodic reviews of retained data to confirm its accuracy, relevance, and the continued necessity of retention.
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          The duration for which we store personal data depends on several factors, including:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li>The terms of our agreement with you and the original purpose for collecting the data</li>
          <li>Any legal or regulatory obligations requiring specific retention periods</li>
          <li>Whether you have submitted a valid request to delete your data, provided that no investigation or contractual obligation exists requiring continued processing</li>
          <li>The presence of any other lawful basis that justifies retaining the data beyond its original purpose</li>
        </ul>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          You may request deletion of your information at any time through the app. If no outstanding obligations remain, we will honor your request and delete your data accordingly.
        </p>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          7. Security Safeguards
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Your personal information is primarily stored in Fairloner databases, which are maintained by our service providers. These databases are hosted on servers located in Nigeria. Fairloner takes appropriate contractual and technical measures to ensure adequate protection of personal data, including during transfers to third parties or across systems within the Fairloner network.
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          We are committed to safeguarding the confidentiality, integrity, and security of your personal information. Reasonable physical, administrative, and technical safeguards are in place to help prevent unauthorized access, disclosure, misuse, or alteration. However, as no method of transmission over the Internet or method of electronic storage is completely secure, we cannot guarantee absolute security and shall not be held responsible for security breaches beyond our reasonable control
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          The security of your data also depends on your actions. Fairloner shall not be liable for any loss, unauthorized access, or misuse of your information resulting from your failure to secure your account credentials (such as username and password) or from any other negligence on your part.
        </p>
        
        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          8. Age Restriction
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Our services are not intended for individuals under the age of 18. We do not knowingly collect or process personal information from anyone under 18 years of age. If you are a parent or legal guardian and become aware that your child has provided us with personal information without your consent, please contact us immediately using the contact details provided in this Privacy Policy so that we can take appropriate action.
        </p>
        
        
        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          9. Contact Us
        </h2>
        <div style={{
          background: '#e6f5ec',
          padding: '15px',
          borderLeft: '4px solid #0C7B3D',
          margin: '1.5em 0',
          borderRadius: '5px'
        }}>
          <strong>Company: JEJELY ULTIMATE LIMITED</strong><br/>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            If you have any questions, complaints, or suggestions regarding our services or products, you may contact us directly through the application or by sending an <strong>Email</strong> to <a href="mailto:fairlonerhelp@gmail.com" style={{ color: '#0C7B3D', textDecoration: 'underline' }}>fairlonerhelp@gmail.com</a>. Our support team will reach out to you via email or phone as soon as possible.
          </p>
        </div>
        

        <div style={{
          textAlign: 'center',
          color: '#666',
          fontSize: '0.9em',
          marginTop: '50px'
        }}>
          ©.2025 JEJELY ULTIMATE LIMITED. Made for Nigeria.
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
